//import logo from './logo.svg';
import './App.css';
import LoanSearchForm from './components/LoanSearchForm';
import LoanResult from './components/LoanResult';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetMessageData } from './actions/redux/messageActions';

function App() {
  const dispatch = useDispatch();
  const miSubId = useSelector(store => store.loanStatus.commitmentOrCertificateNumber);
  
  useEffect(() => {
    GetMessageData(dispatch);
  }, [dispatch]);
  
  return (
    <div className="container" id="appBody">
      {miSubId !== "" ? <LoanResult /> : <LoanSearchForm />}
    </div>
  );
}
export default App;
